var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "../themes/styled";
import * as SS from "styled-system";
export var Box = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    box-sizing: border-box;\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", "\n"], ["\n    box-sizing: border-box;\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", ";\n    ", "\n"])), SS.background, SS.border, SS.boxShadow, SS.color, SS.flexbox, SS.grid, SS.layout, SS.position, SS.space, SS.typography, SS.system({
    transform: {
        property: "transform"
    }
}));
export default Box;
var templateObject_1;
//# sourceMappingURL=Box.js.map